/*
 * Logins are stored in LocalStorage, but they may turn out to be expired.
 * This will not be discovered until after the /ping check has run.
 * In the mean time, components may have been created, trying to fetch resources, which will fail because the user
 * is not authenticated yet.
 * The purpose of this mixin is to postpone certain actions until the stored login has been verified by the /ping check.
 */
export const AuthListener = {
   created() {
      const { onAuthed, dispatchOnAuth } = this.$options;
      const postAuthDispatch = dispatchOnAuth || [];
      const componentCallback = onAuthed ? onAuthed.bind(this) : () => {};
      // Combined callback
      const callback = () => {
         componentCallback();
         postAuthDispatch.forEach(action => {
            // noinspection JSIgnoredPromiseFromCall
            this.$store.dispatch(action);
         });
      };
      const loggedIn = this.$store.getters['auth/loggedIn'];
      if (loggedIn) {
         callback();
      } else {
         this.$bus.$on('auth-ok', () => {
            callback();
         });
      }
   },
};
